var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.0565C12.0003 11.1679 11.0695 12.0565 9.95963 11.9972C7.69806 11.8764 5.22999 10.7689 3.23134 8.77026C1.23125 6.77147 0.123359 4.30238 0.00279144 2.04024C-0.056346 0.930669 0.831763 0 1.94297 0H3.20013C3.50543 0 3.68682 0.258338 3.75599 0.55583L4.30258 2.93024C4.37238 3.23344 4.27947 3.55112 4.0573 3.76895L3.48194 4.33305C3.07043 4.73652 3.00479 5.37607 3.32618 5.85443C3.68594 6.38988 4.11158 6.90946 4.60022 7.39896C5.089 7.8877 5.609 8.31345 6.14493 8.67325C6.62331 8.99442 7.26273 8.92874 7.66614 8.51734L8.23044 7.94184C8.44828 7.71969 8.76597 7.62679 9.06919 7.69658L11.4437 8.24314C11.7413 8.3123 11.9996 8.4936 11.9996 8.79897L12 10.0565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactWhite);
export default __webpack_public_path__ + "static/media/contact-white.c4aa9541f78b49680cbc4f2b5f1575a8.svg";
export { ForwardRef as ReactComponent };